import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (formbody) => async (dispatch) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const url = ApiUrl2+'division-setting-delete';
    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': UserToken,
        },
        body: JSON.stringify(formbody)
    };
    const response = await doFetch(url,argument);
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : response.ok });
    
    return response;
    
};